import { useTheme } from '@material-ui/core/styles'
import { Maybe } from '@ts/operations'
import React from 'react'

import { Theme } from '../../lib/theming/Theme'
import Annotation from './Annotation'
import ReleaseCard, { ReleaseCardProps } from './ReleaseCard'
import { Shape } from './ReleaseCardTag'

const PromotedReleaseCard = (
  props: ReleaseCardProps & {
    annotation?: {
      bgColor?: Maybe<string>
      label?: Maybe<string>
    }
    height?: string
  }
) => {
  const { annotation, height, ...releaseCardProps } = props

  const { palette } = useTheme<Theme>()
  const textColor = palette.secondary.contrastText
  const titleColor = palette.common.white

  const card = (
    <ReleaseCard
      {...releaseCardProps}
      styles={{
        cardBackgroundColor: palette.secondary.main,
        cardTextColor: textColor,
        descriptionTextColor: textColor,
        priceTextColor: textColor,
        titleHeadingColor: titleColor,
        titleTextColor: titleColor,
      }}
      variant="promoted"
    />
  )
  if (!annotation?.label) return card

  const { bgColor, label } = annotation
  return (
    <Annotation bgColor={bgColor} height={height} shape={Shape.Circle} text={label}>
      {card}
    </Annotation>
  )
}
export default PromotedReleaseCard
